import React from 'react';
import {Pagination} from "react-bootstrap";

function STCPaginationLast(props){
    return(
        <Pagination.Last
            style={props.style}
            className={props.className}
            onClick={props.onClick}
        >
            {props.children}
        </Pagination.Last>
    )
}
export default STCPaginationLast;